import styled from 'styled-components';

export const Container = styled.div`
    max-width: min(480px, 100%);
    margin: 0 auto;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
`;
